'use client'

import cx from 'classnames'

import BuilderTextContent from 'components/BuilderTextContent'
import Loader from 'components/Loader'
import Page from 'components/Page'
import FooterPortal from 'containers/Layouts/Layout/FooterPortal'
import Shop from 'pageContainers/Shop'
import { useAppSelector } from 'store/hooks'
import { isAppInitializedSelector } from 'store/modules/appConfig/selectors'
import { offersLoadedSelector } from 'store/modules/shop/selectors'

import classes from './styles.module.scss'

export default function Store(props: { content?: any; builderPage: string }) {
  const appInitialized = useAppSelector(isAppInitializedSelector)
  const offersLoaded = useAppSelector(offersLoadedSelector)

  if (!appInitialized || !offersLoaded) {
    return (
      <Page className={cx(classes.root, classes.loading)} rootClassName={classes.rootWithMargin}>
        <Loader />
      </Page>
    )
  }

  return (
    <>
      <Page className={classes.root} rootClassName={classes.rootWithMargin}>
        <Shop />
      </Page>

      {props.content && <BuilderTextContent content={props.content} model={props.builderPage} />}

      <FooterPortal />
    </>
  )
}
